export const html = (templateStrings, ...substitutions) => {
  let result = "";

  for (let i = 0; i < templateStrings.length; i++) {
    result += templateStrings[i];
    if (i < substitutions.length) result += substitutions[i];
  }

  return result;
};

const template = document.createElement("template");
template.innerHTML = html`
  <style>
    * {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    .page {
      margin-left: 18px;
      margin-top: 24px;
    }

    hgroup {
      border-bottom-style: solid;
      border-bottom-width: 0.5px;
      border-color: rgba(0, 0, 0, 0.38);
    }

    .breadcrumb ol {
      align-items: end;
      display: flex;
      flex-wrap: wrap;
      font-size: 14px;
    }

    .breadcrumb li:not(:first-child)::before {
      color: rgba(0, 0, 0, 0.38);
      content: "/";
      display: inline-block;
      margin: 0 0.25rem;
    }

    a {
      color: var(--v-anchor-base);
      cursor: pointer;
      text-decoration: none;
    }

    .breadcrumb span {
      color: rgba(0, 0, 0, 0.38);
    }

    h1 {
      color: var(--v-primary-base);
      font-size: 1.6rem;
    }

    h2 {
      font-size: 1.2rem;
      margin-top: 20px;
    }

    p {
      margin-bottom: 5px;
      margin-bottom: 10px;
      max-width: 1000px;
    }
  </style>

  <div class="page">
    <hgroup>
      <nav aria-label="Breadcrumb" class="breadcrumb">
        <ol>
          <li><a href="#">Build</a></li>
          <li><span aria-current="page">Introduction</span></li>
        </ol>
      </nav>
      <h1>Introduction</h1>
    </hgroup>

    <main>
      <h2>About the OCHIN Install Tool</h2>
      <p>
        This will be your home for data entry as we collect all the information
        necessary to complete your transition to our member network.
      </p>

      <h2>Getting Started</h2>
      <p>
        Your install project manager will be reaching out regarding the next
        steps in the OCHIN install process and introduce your install team.
        Please work with your install team to complete the following
        deliverables. The deliverables include additional information regarding
        the users and structure of your clinics and departments. This section
        may be filled out by multiple people in your organization - please
        forward to whomever should be included.
      </p>
      <p>
        If you have questions or need assistance completing the Epic Build,
        please contact your install project manager.
      </p>
    </main>
  </div>
`;

export class Intro extends HTMLElement {
  constructor() {
    super();

    this.attachShadow({ mode: "open" });
    const root = this.shadowRoot;
    if (root === null) throw new Error("root is null");

    root.appendChild(template.content.cloneNode(true));
  }
}

customElements.define("o-intro", Intro);
